import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {BypassRouteChangeService} from '../bypass-route-change/bypass-route-change.service';

@Component({
    selector: 'app-route-change-monitor-popup',
    templateUrl: './route-change-monitor-popup.component.html',
    styleUrls: ['./route-change-monitor-popup.component.css']
})
export class RouteChangeMonitorPopupComponent implements OnInit, OnDestroy {

    @ViewChild('popup')
    popUp: any;

    private popupUrl: string;
    private subscription: Subscription;
    private routeMatches: Array<RegExp>;

    constructor(
        private router: Router,
        private modalService: NgbModal,
        private bypassRouteChangeService: BypassRouteChangeService
    ) {
        this.routeMatches = [
            /^\/loanApplication$/,
            /^\/loanApplication\/newLoanProcess$/,
            /^\/loanApplication\/newLoanProcess\/\d+$/,
            /^\/loanApplication\/newLoanProcess\/\d+\/details$/,
            /^\/loanApplication\/newLoanProcess\/\d+\/loan$/,
            /^\/loanApplication\/newLoanProcess\/\d+\/residence-details$/,
            /^\/loanApplication\/newLoanProcess\/\d+\/employeeDetails$/,
            /^\/loanApplication\/newLoanProcess\/\d+\/status$/,
            /^\/loanApplication\/newLoanProcess\/\d+\/sentLink$/
        ];
    }

    ngOnInit() {
        this.registerRouteChangeListener();

        this.bypassRouteChangeService.bypassRouteChange = false;
    }

    registerRouteChangeListener() {
        this.subscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                let doesRouteMatched = this.routeMatches.find(routeMatch => routeMatch.test(event.url));
                if (!doesRouteMatched && !this.bypassRouteChangeService.bypassRouteChange) {
                    this.router.navigateByUrl(this.router.url, {replaceUrl: true});
                    this.subscription.unsubscribe();
                    this.popupUrl = event.url;
                    this.openPopup();
                    this.registerRouteChangeListener();
                }
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    open(content) {
        this.modalService.open(content);
    }

    openPopup() {
        this.open(this.popUp);
    }

    proceed() {
        this.subscription.unsubscribe();
        this.router.navigateByUrl(this.popupUrl).then(() => true);
    }
}
